import { LEVEL } from "../../consts";
import type { Level } from "../../types";

export const handleLevel = (learningObjectTypology?: Level) => {
  switch (learningObjectTypology) {
  case LEVEL.COURSE :
    return "course";
  case LEVEL.DA_EXTERNAL_RES:
    return "learning_activity";
  case LEVEL.DA_SCORM:
    return "learning_activity";
  case LEVEL.DA_XAPI:
    return "learning_activity";
  case LEVEL.DA_PHYSICAL_CLASS:
    return "learning_activity";
  case LEVEL.DA_VIRTUAL_CLASS:
    return "learning_activity";
  case LEVEL.PATH :
    return "package";
  default:
    return "learning_activity";
  }
};
